import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.companyCatalogAdd || initialState;

export const selectTests = createSelector(
  [selectDomain],
  (state) => state.tests
);

export const selectDropdowns = createSelector(
  [selectDomain],
  (state) => state.dropdowns
);

export const selectCompanyDetails = createSelector(
  [selectDomain],
  (state) => state.companyDetails
);

export const selectFetchingCompanyDetails = createSelector(
  [selectDomain],
  (state) => state.fetchingCompanyDetails
);

export const selectFetchingTests = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectFetchingDropdowns = createSelector(
  [selectDomain],
  (state) => state.fetchingDropdown
);

export const selectTestCount = createSelector(
  [selectDomain],
  (state) => state.testCount
);

export const selectCompanyCatalog = createSelector(
  [selectDomain],
  (state) => state.companyCatalog
);

export const selectCommodityCategories = createSelector(
  [selectDomain],
  (state) => state.filters.categories
);

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.filters.commodities
);

export const selectTestCategories = createSelector(
  [selectDomain],
  (state) => state.filters.testCategories
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading || state.fetchingFilters
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);
